<template>
    <div>
      <div v-if="websiteModule">
      <v-input type="text" name="surName" title="Surnom" v-model="newUser.surName"></v-input>
      <v-ckeditor name="description" title="Courte présentation" v-model="newUser.description"></v-ckeditor>
        <div class="portlet light" style="border: 1px solid #C2CAD8;">
          <div class="ss-titre text-left">
            <strong>Diplômes</strong>
          </div>
          <div class="customContainer">
            <div>
              <v-input
                  type="text"
                  name="name"
                  title="Ajouter un diplôme"
                  v-model="certificate.name"
                  @enter="sendCertificate"
                  reference="name"
                  unit="">
              </v-input>
            </div>
            <div class="hidden-xs">
              <button class="btn blue" style="margin-bottom: 1.5rem;" @click="sendCertificate">{{ met === 'post' ? 'Ajouter' : 'Modifier' }}</button>
              <button class="btn red" style="margin-bottom: 1.5rem;" v-if="met === 'put'" @click="cancelEdit">Annuler</button>
            </div>
            <div class="visible-xs" style="width: 100%">
              <button class="btn blue btn-block" style="margin-bottom: 1.5rem;" @click="sendCertificate">{{ met === 'post' ? 'Ajouter' : 'Modifier' }}</button>
              <button class="btn red btn-block" style="margin-bottom: 1.5rem;" v-if="met === 'put'" @click="cancelEdit">Annuler</button>
            </div>
          </div>
          <div class="ss-titre text-left">
              <span>Diplômes ajoutés</span>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="(certificate, index) in certificates" style="display: flex; justify-content: space-between; align-items: center">
              {{ certificate.name }}
              <div>
                <button>
                    <i class="icon-pencil" style="color: black;" @click="editCertificate(certificate, index)"></i>
                </button>
                <button>
                    <i class="fas fa-trash" style="color: black;" @click="deleteCertificate(certificate, index)"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
        <div class="portlet light" style="border: 1px solid #C2CAD8;">
          <div>
            <div class="ss-titre text-left">
              <strong>Carte professionnelle&nbsp;</strong>
              <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true"
                    :data-original-title="tooltip">
              <i class="icon-info"></i>
              </span>
              <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true"
                    :data-original-title="tooltip">
              <i class="icon-info"></i>
              </span>
            </div>
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <div class="form-group">
                  <v-input type="text" name="birthdate" title="Date de naissance" v-model="newUser.birthdate"></v-input>
                </div>
              </div>
              <div class="col-md-6 col-xs-12">
                  <v-input type="text" name="card_pro_number" title="Numéro carte professionnelle" v-model="newUser.card_pro_number"></v-input>
              </div>
            </div>
          </div>
        </div>

    <div class="margin-top-10">
      <button class="btn green" @click="updateUser">Sauvegarder</button>
    </div>
  </div>
</template>

<script>
export default {

  name: 'UserPersonalsForm',
  props: {
    tooltip: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    },
    websiteModule: {
      type: Boolean,
    }
  },
  data () {
    return {
      form: {},
      certificates: this.user.certificates,
      certificate: {},
      newUser: this.user,
      met: 'post'
    }
  },
  methods: {
    async updateUser() {
      await axios.put(`/user/${this.user.id}`, this.user)

      this.$snotify.success("Informations personelles mises a jour")
    },
    async sendCertificate() {
      const response = await axios[this.met](this.met === 'post' ? `/user/certificate/${this.user.id}` : `/user/certificate/${this.certificate.id}`, this.certificate)

      if (this.met === 'post') {
        this.$snotify.success("Le diplôme a bien été créé")
      } else {
        this.$snotify.success("Le diplôme a bien été mis a jour")
        this.met = 'post'
      }
      this.certificate = {}

      this.certificates.push(response.data['certificate'])
    },
    editCertificate(certificate, index) {
      this.met = 'put'

      this.$delete(this.certificates, index)

      this.certificate = certificate
    },
    cancelEdit() {
      this.certificate = {}

      this.certificates.push(this.certificate)
    },
    async deleteCertificate(certificate, index) {
      this.$delete(this.certificates, index)

      await axios.delete(`/user/certificate/${certificate.id}`)

      this.$snotify.success("Diplôme supprimé avec succès")
    }
  }
};
</script>

<style lang="css" scoped>
  .customContainer{
    display: flex;
  }
  .customContainer > div {
    align-self: flex-end;
    flex-grow: 1
  }
  @media (max-width: 992px) {
    .customContainer{
      flex-direction: column;
    }
    .customContainer > div {
      width: 100%;
      align-self: flex-end;
      flex-grow: 1;

    }
  }
</style>

